module.exports = __webpack_public_path__ + "static/img/white-2x.b0a9ef0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/white-2x.png
// module id = 6JKn
// module chunks = 0